export default __webpack_public_path__ + "static/media/2627 utensils top.6402d917.png";